import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const ExpoModulesContext = createContext();

export const ExpoModulesProvider = ({ children, modules }) => {
  return <ExpoModulesContext.Provider value={modules}>{children}</ExpoModulesContext.Provider>;
};

ExpoModulesProvider.propTypes = {
  children: PropTypes.node.isRequired,
  modules: PropTypes.shape({
    Updates: PropTypes.object,
    Constants: PropTypes.object,
    Device: PropTypes.object,
    Notifications: PropTypes.object,
  }).isRequired,
};

export const useExpoModules = () => {
  const context = useContext(ExpoModulesContext);
  if (!context) {
    throw new Error('useExpoModules must be used within an ExpoModulesProvider');
  }
  return context;
};
